module.exports = __webpack_public_path__ + "img/xft.394fec53.png";